import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Clock3, ShieldCheck } from "lucide-react";
import { ThemeProvider } from "../contexts/ThemeContext";
import SpaceJetNavbar from "../components/SpaceJetNavbar";
import SpaceJetParticleField from "../components/SpaceJetParticleField";

const SpaceJetNetworkPendingApproval = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const type = params.get('type') || 'client';

  return (
    <ThemeProvider>
      <div className="min-h-screen bg-[#050b17] text-slate-100 spacejet-texture-dots spacejet-texture-living transition-colors duration-300" style={{ '--spacejet-texture-dot-opacity': 0.105, '--spacejet-texture-grid-opacity': 0.07, '--spacejet-texture-ambient-opacity': 0.085, '--spacejet-texture-drift-duration': '50s', '--spacejet-texture-glow-duration': '35s', '--spacejet-texture-sheen-duration': '41s' }}>
        <SpaceJetNavbar />
        <SpaceJetParticleField maxParticles={24} speed={0.12} baseOpacity={0.18} />

        <div className="mx-auto flex min-h-[calc(100vh-5rem)] max-w-xl items-center px-4 py-12 sm:px-6 lg:px-8">
          <div className="spacejet-surface-card w-full rounded-2xl p-8 text-center">
            <div className="mx-auto mb-5 inline-flex h-16 w-16 items-center justify-center rounded-full bg-slate-700/60">
              <Clock3 className="h-8 w-8 text-slate-200" />
            </div>
            <div className="spacejet-page-kicker mb-3 justify-center">Pending approval</div>
            <h1 className="spacejet-page-title mb-3 text-3xl font-semibold text-slate-100">Approval pending</h1>
            <p className="spacejet-page-copy mb-6">Your {type === 'admin' ? 'admin' : 'client'} account request is pending review.</p>
            <p className="mb-8 text-sm text-slate-400">You can sign in after approval. If you already requested access, no further action is needed.</p>
            <div className="mx-auto mb-6 inline-flex items-center gap-2 rounded-lg border border-white/[0.08] bg-white/[0.03] px-4 py-2 text-sm text-slate-300">
              <ShieldCheck className="h-4 w-4" />
              Status: pending approval
            </div>
            <Link to="/login" className="spacejet-btn-primary inline-flex items-center justify-center rounded-lg px-6 py-3 font-semibold transition-colors">
              Back to login
            </Link>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default SpaceJetNetworkPendingApproval;
